import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {
    tokenLogin,
    getApplicationInfoDocument,
    msalLogin,
} from './utility/firebase';
import {useUserContext} from './user-provider'

type Props = {
  children: React.ReactNode;
  url: string;
}

const Login = ({ children, url }: Props) => {
  const [open, setOpen] = React.useState(true);
  // 認証完了状態を管理するstate（認証完了まで子コンポーネントを非表示にするため）
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const handleAuthSuccess = () => {
    setIsAuthenticated(true);  // 認証完了フラグを設定
    setOpen(false);
  };
  const user = useUserContext();

  React.useLayoutEffect(() => {
    const sync = async () => {
      if (process.env.REACT_APP_MODE === "local") {
        await tokenLogin(url)
          .then((val) => {
            if(val === 'unprocessed'){
              // 未処理の場合はバックドロップ消さない
              return;
            }
            if(user.setUserData){
              user.setUserData(val as string);
            }
            // トークン取得
            getApplicationInfoDocument();
            // 認証に成功したら子コンポーネントを表示可能にする
            handleAuthSuccess();
          }).catch((e) => {
            console.log(e)
          })
      } else {
        await msalLogin(url)
          .then((val) => {
            if (val === "unprocessed") {
                // 未処理の場合はバックドロップ消さない
                return;
            }
            if (user.setUserData) {
                // localStorageにuserInfoが保存されている場合は優先して使用
                const userInfo = localStorage.getItem("userInfo");
                const userData = userInfo ? userInfo : val as string;
                user.setUserData(userData);
            }
            // トークン取得
            getApplicationInfoDocument();
            // 認証に成功したら子コンポーネントを表示可能にする
            handleAuthSuccess();
          })
          .catch((e) => {
              console.log(e);
          });
      }
    };
    sync();
  },[])

  return (
    <>
      <div>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 10 }}
          open={open}
          invisible={false}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      {/* 認証完了後のみ子コンポーネント（UtilityProvider以下）を表示 */}
      {isAuthenticated && children}
    </>
  )
}

export default Login